import { GAME_EVENTS, USER_CLICKED_GAME_EVENT } from "../../constants/game";
import { SCENE_INTERACTION } from "../../constants/scene";
import { ICON } from "../Icons/Icons";
import { SCENE_EVENTS } from "../MVC/Model";
import { FoldableColumnMenu } from "./Navbar";
import { BottomNavbarCenterMenu } from "./BottomNavBarMenu";
import { SOCKET_EVENTS } from "../../socket/Events";


class ControlChatHistoryButton {
  static template() {
    return `
      <div id='chess-history' class="world-bottom-nav__area__item own_chair__controls__mic">
        ${ICON.HISTORY}
        
        <span class="own-chess-menu__item__text" data-lang="chess-history-text">${$trans('chess-history-text')}</span>
      </div>
    `;
  }
}

class ControlSeatMicButton {
  static template() {
    return `
      <div id='chess-toggleAudioTrack' class="world-bottom-nav__area__item own_chair__controls__mic">
        ${ICON.MIC_ON}
        ${ICON.MIC_OFF}
      </div>
    `;
  }
}

class ControlSeatCameraButton {
  static template() {
    return `
      <div id='chess-toggleVideoTrack' class="world-bottom-nav__area__item own_chair__controls__camera">
        ${ICON.CAMERA_ON}
        ${ICON.CAMERA_OFF}
      </div>
    `;
  }
}

class ControlExitModeButton {
  static template() {
    return `
    <div id="chess-leave-chair" class="world-bottom-nav__area__item world-bottom-nav__area__exit own_chair__controls__exit">
      ${ICON.EXIT}
    </div>
    `;
  }
}

class ControlFlipButton {
  static template() {
    return `
    <div id="chess-flip" class="world-bottom-nav__area__item world-bottom-nav__area__flip own_chair__controls__flip">
      ${ICON.FLIP}
      <span class="own-chess-menu__item__text" data-lang="chess-flip-table-text">${$trans('chess-flip-table-text')}</span>
    </div>
    `;
  }
}

class ControlRestartButton {
  static template() {
    return `
    <div id="chess-restart" class="world-bottom-nav__area__item world-bottom-nav__area__restart own_chair__controls__restart">
      ${ICON.RESTART}
      
      <span class="own-chess-menu__item__text" data-lang="chess-restart-text">${$trans('chess-restart-text')}</span>
    </div>
    `;
  }
}

class ControlLockButton {
  static template() {
    return `
    <div id="chess-lock" class="world-bottom-nav__area__item world-bottom-nav__area__lock own_chair__controls__lock">
      ${ICON.LOCK}
      ${ICON.UNLOCK}
      
      <span class="own-chess-menu__item__text" data-lang="chess-lock-game-text">${$trans('chess-lock-game-text')}</span>
    </div>
    `;
  }
}
export default class OwnChessMenu extends BottomNavbarCenterMenu {
  static selector() {
    return $('#own-chess-menu')
  }

  /**
   * @param {import('../MVC/Model').Model} model
   * @param {import('./Navbar').Navbar} navbar
   */
  constructor({ model, navbar }) {
    super()

    this.model = model;
    this.navbar = navbar;
    this.actionWrapper = $(this.template());

    this.audioTrackControl = this.actionWrapper.find("#chess-toggleAudioTrack");
    this.videoTrackControl = this.actionWrapper.find("#chess-toggleVideoTrack");
    this.lockControl = this.actionWrapper.find("#chess-lock");
    this.restartControl = this.actionWrapper.find("#chess-restart");
    this.exitControl = this.actionWrapper.find("#chess-leave-chair");
    this.infoControl = this.actionWrapper.find("#chess-info");
    this.historyControl = this.actionWrapper.find("#chess-history");
    this.flipControl = this.actionWrapper.find("#chess-flip");

    this.isAudioMuted = false;
    this.isVideoOff = false;
    this.isRoomLocked = false;

    this.init();
  }

  init() {
    OwnChessMenu.attach(this.actionWrapper)
    this.initListeners();
    this.initButtonHandlers();
    this.chessFoldableMenu = new FoldableColumnMenu('own-chess-menu__foldable')
    this.chessFoldableMenu.init()
    this.actionWrapper.hide();
    this.chessFoldableMenu.toggleFoldable(false);
  }

  resetStates() {
    this.model.chessModeController.unmuteLocalMic();
    this.isAudioMuted = false;
    this.audioTrackControl.removeClass("is-off");

    this.model.chessModeController.turnOnLocalCamera();
    this.isVideoOff = false;
    this.videoTrackControl.removeClass("is-off");

    this.isRoomLocked = false;
    this.lockControl.removeClass("is-off");
  }

  template() {
    return `
      <section id="own-chess-menu" class="world-bottom-nav__area world-bottom-nav__center_area own-chess-menu">
        <div class="own-chess-menu__foldable-wrapper">
          ${FoldableColumnMenu.generateTemplate(
      'own-chess-menu__foldable',
      `
              <section class="own-chess-menu__foldable">
              ${ControlRestartButton.template()}
              ${ControlFlipButton.template()}
              ${ControlChatHistoryButton.template()}
              ${ControlLockButton.template()}
              </section>
            `,
      ICON.THREE_DOTS,
    )}
        </div>
        ${ControlSeatMicButton.template()}
        ${ControlSeatCameraButton.template()}
        ${ControlExitModeButton.template()} 
      </section>
    `;
  }

  initButtonHandlers() {
    this.audioTrackControl.on('click', () => {
      if (this.isAudioMuted) {
        this.model.chessModeController.unmuteLocalMic();
        this.isAudioMuted = false;
        this.audioTrackControl.removeClass("is-off");
      } else {
        this.model.chessModeController.muteLocalMic();
        this.isAudioMuted = true;
        this.audioTrackControl.addClass("is-off");
      }
    });

    this.videoTrackControl.on('click', () => {
      if (this.isVideoOff) {
        this.model.chessModeController.turnOnLocalCamera();
        this.isVideoOff = false;
        this.videoTrackControl.removeClass("is-off");
      } else {
        this.model.chessModeController.turnOffLocalCamera();
        this.isVideoOff = true;
        this.videoTrackControl.addClass("is-off");
      }
    });

    this.lockControl.on('click', () => {
      this.isRoomLocked = !this.isRoomLocked;
      this.lockControl.toggleClass("is-off", this.isRoomLocked);
      if (this.isRoomLocked) {
        this.model.dispatchEvent({ type: USER_CLICKED_GAME_EVENT.LOCK });
      } else {
        this.model.dispatchEvent({ type: USER_CLICKED_GAME_EVENT.UNLOCK });

      }
    });

    this.restartControl.on('click', () => {
      this.model.dispatchEvent({
        type: GAME_EVENTS.RESTART_GAME
      });
    });

    // this.exitControl.on('click', () => {
    //   if (this.model.elementSelected && this.model.elementSelected.parent) {
    //     this.model.elementSelected.parent.quitGame();
    //   }
    // });

    this.infoControl.on('click', () => {
      this.model.alert('info', $trans('chess-controls-info', {}, 'Chess Game Controls'), {
        area: 'middle'
      });
    });

    this.historyControl.on('click', () => {
      this.model.dispatchEvent({ type: USER_CLICKED_GAME_EVENT.HISTORY });
    });
  }

  initListeners() {
    const hideEvents = [
      SCENE_INTERACTION.SET_OCCUPIED_SEATS,
      SCENE_EVENTS.TOUR_MODE_ENDED,
      SCENE_EVENTS.GUIDED_MODE_STOP,
      SCENE_EVENTS.GUIDE_MODE_OFF,
      SCENE_EVENTS.UPDATE_TOUR_UI_ON_SOCKET_DATA,
      SCENE_EVENTS.TOUR_MODE_WINDOW_CLOSED,
    ];

    hideEvents.forEach((eventName) => {
      this.model.addEventListener(eventName, () => {
        this.model.syncButtonNavUI();
      });
    });

    this.model.addEventListener(SCENE_EVENTS.USER_SEAT_TURN_MIC_ON, () => {
      this.isAudioMuted = false;
      this.audioTrackControl.removeClass("is-off");
    });

    this.model.addEventListener(SCENE_EVENTS.USER_SEAT_TURN_MIC_OFF, () => {
      this.isAudioMuted = true;
      this.audioTrackControl.addClass("is-off");
    });

    this.model.addEventListener(SCENE_EVENTS.USER_SEAT_TURN_CAMERA_ON, () => {
      this.isVideoOff = false;
      this.videoTrackControl.removeClass("is-off");
    });

    this.model.addEventListener(SCENE_EVENTS.USER_SEAT_TURN_CAMERA_OFF, () => {
      this.isVideoOff = true;
      this.videoTrackControl.addClass("is-off");
    });
    this.model.addEventListener(SCENE_EVENTS.SHOW_CHESS_MENU, () => {
      this.audioTrackControl.hide();
      this.videoTrackControl.hide();
      this.restartControl.hide();
      this.lockControl.hide();
      this.flipControl.hide();
      this.historyControl.hide();
      this.chessFoldableMenu.toggleFoldable(false);
      OwnChessMenu.show();
    });
    this.model.addEventListener(SCENE_EVENTS.SHOW_OWN_CHAIR_MENU, () => {
      this.hide();
    });
    this.model.addEventListener(SCENE_EVENTS.HIDE_CHESS_MENU, () => {
      this.resetStates();
      this.audioTrackControl.hide();
      this.videoTrackControl.hide();
      this.restartControl.hide();
      this.lockControl.hide();
      this.flipControl.hide();
      this.chessFoldableMenu.toggleFoldable(false);
      this.navbar.disableChessModeNavbar();
      this.hide();
    });

    this.model.addEventListener(SCENE_EVENTS.SHOW_CHESS_PLAYER_MODE_MENU, () => {
      this.restartControl.show();
      this.lockControl.show();
      this.audioTrackControl.show();
      this.videoTrackControl.show();
      this.flipControl.show();
      this.historyControl.show();
      this.chessFoldableMenu.toggleFoldable(true);
      this.navbar.enableChessModeNavbar();
    });

    this.model.addEventListener(SCENE_EVENTS.SHOW_CHESS_SPECTATOR_MODE_MENU, () => {
      this.audioTrackControl.show();
      this.videoTrackControl.show();
      this.historyControl.show();
      this.restartControl.hide();
      this.lockControl.hide();
      this.flipControl.hide();
      this.chessFoldableMenu.toggleFoldable(false);
      this.navbar.enableChessModeNavbar();
    });

    this.model.addEventListener(GAME_EVENTS.CHESS_CONTROLLER_CONNECTED, () => {
      OwnChessMenu.show();
      if (this.model.chessModeController) {
        this.isAudioMuted = this.model.chessModeController.isMicMuted;
        this.audioTrackControl.toggleClass("is-off", this.isAudioMuted);

        this.isVideoOff = this.model.chessModeController.isCameraOff;
        this.videoTrackControl.toggleClass("is-off", this.isVideoOff);

        this.isRoomLocked = this.model.chessModeController.gameLocked;
        this.lockControl.toggleClass("is-off", this.isRoomLocked);
      }
    });
    this.model.socket.addEventListener(SOCKET_EVENTS.GAMING_DATA, (e) => {
      const payload = e.data;
      if (payload.eventName === GAME_EVENTS.CHESS_GAME_LOCKED) {
        this.model.chessModeController.gameLocked = true;
        this.isRoomLocked = true;
        this.lockControl.addClass("is-off");
      }
    });
    this.model.socket.addEventListener(SOCKET_EVENTS.GAMING_DATA, (e) => {
      const payload = e.data;
      if (payload.eventName === GAME_EVENTS.CHESS_GAME_UNLOCKED) {
        this.model.chessModeController.gameLocked = false;
        this.isRoomLocked = false;
        this.lockControl.removeClass("is-off");
      }
    });
  }

  hide() {
    OwnChessMenu.hideAllBottomNavMenu();
    this.model.syncButtonNavUI();
  }
}
